import { NEW_TABID_PREFIX, NEW_TABNAME_PREFIX } from './constants';

const getNewTab = (tabs = []) => {
  const unsavedTabs = tabs.filter(item => !!item.unsaved);

  let index = 0;
  let node = true;

  while (node) {
    index += 1;
    const id = NEW_TABID_PREFIX + index;
    node = unsavedTabs.find(item => `${item.id}` === id);
  }

  return {
    id: NEW_TABID_PREFIX + index,
    name: NEW_TABNAME_PREFIX + index,
  };
};

export default getNewTab;
